







































































































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import Loader from '@/components/Loader.vue'
import Card from './Card.vue'
import CustomCharacter from './CustomCharacter.vue'
import ConfirmPurchaseModal from './ConfirmPurchaseModal.vue'

export type AvailableItem = {
	id: string
	name: string
	category: string //'BACKGROUND'
	status: 'AVAILABLE' | 'DEPRECATED' | 'COMING_SOON'
	file: string
	price: string
	is_purchased: boolean
}

export type PurchasedItem = {
	id: string
	name: string
	created: string
	modified: string
	item: AvailableItem
	file: string
	price: string
	is_activated: boolean
}

type ListOfItems<T> = {
	loading?: boolean
	error?: null | string | Error
	data?: T[]
}
type ListOfAvailableItems = ListOfItems<AvailableItem>
type ListOfPurchasedItems = ListOfItems<PurchasedItem>

@Component({
	components: { Loader, Card, CustomCharacter, ConfirmPurchaseModal },
})
export default class PageShop extends Vue {
	isBuyModalOpen = false
	isConfirmModalOpen = false
	confirmItem: AvailableItem | null = null
	confirmLoading = false

	isMobileMenuOpen = false

	listOfHeroes: ListOfAvailableItems = {
		loading: true,
	}

	listOfBackgrounds: ListOfAvailableItems = {
		loading: true,
	}

	listOfClothes: ListOfAvailableItems = {
		loading: true,
	}

	listOfFaces: ListOfAvailableItems = {
		loading: true,
	}

	listOfSuvenirs: ListOfAvailableItems = {
		loading: true,
	}

	tab: string = 'heroes'

	listOfAvailableItems: ListOfAvailableItems = {
		loading: true,
	}
	listOfPurchasedItems: ListOfPurchasedItems = {
		loading: true,
	}

	get profile() {
		return this.$store.state.myProfile
	}

	onClickBought() {
		this.tab = 'purchased'
	}

	// updateCharacter() {
	// 	this.$root.$refs.character.updateCharacter()
	// }

	requestListOfAvailableItems() {
		this.listOfAvailableItems = { loading: true }
		this.axios({
			url: '/eshop/items',
		})
			.then(({ data }) => {
				if (data) {
					// console.log(data)

					this.listOfAvailableItems = { data }

					this.listOfHeroes = data.filter(
						(item: AvailableItem) => item.category == 'HERO'
					)

					this.listOfBackgrounds = data.filter(
						(item: AvailableItem) => item.category == 'BACKGROUND'
					)

					this.listOfClothes = data.filter(
						(item: AvailableItem) =>
							item.category == 'CAP' ||
							item.category == 'PANTS' ||
							item.category == 'TRANSPORTS' ||
							item.category == 'DEVICES' ||
							item.category == 'ANIMALS' ||
							item.category == 'ACCESSORIES'
					)

					this.listOfFaces = data.filter(
						(item: AvailableItem) => item.category == 'FACE'
					)

					this.listOfSuvenirs = data.filter(
						(item: AvailableItem) => item.category == 'SOUVENIR'
					)
				} else {
					this.listOfAvailableItems = { error: 'Error has occurred' }
				}
			})
			.catch(() => {
				this.listOfAvailableItems = { error: 'Error has occurred' }
			})
	}

	requestListOfPurchasedItems() {
		this.listOfPurchasedItems = { loading: true }
		this.axios({
			url: '/eshop/items/purchased',
		})
			.then(({ data }) => {
				if (data) {
					this.listOfPurchasedItems = { data }

					const listOfActiveItems = data.filter(
						(el: PurchasedItem) => el.is_activated === true
					)

					localStorage.setItem(
						'savedActiveItems',
						JSON.stringify(listOfActiveItems)
					)

					//@ts-ignore
					this.$root.$refs.character.updateCharacter()
				} else {
					this.listOfPurchasedItems = { error: 'Error has occurred' }
				}
			})
			.catch(() => {
				this.listOfPurchasedItems = { error: 'Error has occurred' }
			})
	}

	requestMyBalance() {
		// reload my profile data
		this.axios({
			method: 'get',
			url: 'users/user/me',
		}).then(response => {
			window.localStorage.setItem('userProfile', JSON.stringify(response.data))
			this.$store.commit('changeMyProfile', response.data)
		})
	}

	/**
	 * On initialize - make request for list
	 * of available and purchased items
	 */
	created() {
		this.requestListOfAvailableItems()
		this.requestListOfPurchasedItems()
		this.requestMyBalance()
	}

	onItemBought() {
		this.requestListOfAvailableItems()
		this.requestListOfPurchasedItems()
		this.requestMyBalance()
		this.tab === 'purchased'

		this.isBuyModalOpen = true
	}

	onChangeActivated() {
		this.requestMyBalance()
		this.requestListOfPurchasedItems()
	}

	onConfirmPurchase(item: any) {
		this.confirmItem = item
		this.isConfirmModalOpen = true
	}

	cancelConfirmPurchase() {
		this.isConfirmModalOpen = false
		this.confirmItem = null
	}

	confirmPurchase() {
		if (!this.confirmItem) return
		this.confirmLoading = true
		this.axios({
			method: 'post',
			url: `eshop/items/${this.confirmItem.id}/purchase`,
		})
			.then(() => {
				this.confirmLoading = false
				this.isConfirmModalOpen = false
				this.confirmItem = null
				this.onItemBought()
			})
			.catch((e: any) => {
				this.confirmLoading = false
				if (e?.response?.data?.detail === 'not enough indigo dollars') {
					;(this as any).$toast(this.$t('pageShop.toast.notEnoughMoney'), {
						className: ['btn-danger', 'notif'],
						duration: 3000,
					})
				} else {
					;(this as any).$toast(this.$t('pageShop.toast.error'), {
						className: ['btn-danger', 'notif'],
						duration: 3000,
					})
				}
			})
	}

	isHeroActivated() {
		if (this.listOfPurchasedItems?.data) {
			return this.listOfPurchasedItems.data.find(
				el => el.item?.category == 'HERO' && el.is_activated == true
			)
		}

		return null
	}

	openMobileMenu() {
		this.isMobileMenuOpen = !this.isMobileMenuOpen
	}

	changeTab(name: string) {
		this.tab = name
		this.isMobileMenuOpen = false
	}

	getTabName() {
		if (this.tab == 'purchased') {
			return 'pageShop.tabs.purchased'
		}

		return this.tab[0].toUpperCase() + this.tab.slice(1)
	}
}
